const tabs_wrap = document.querySelectorAll('[data-tab-wrap]');
tabs_wrap.forEach(wrap => {
    const tabs = wrap.querySelectorAll('[data-tab-target]');
    const tabContents = wrap.querySelectorAll('[data-tab-content]');

    const content_heading = wrap.querySelector('[data-tab-content-heading]');
    const content_text = wrap.querySelector('[data-tab-content-text]');
    const settings = wrap.querySelector('[data-tab-settings]');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = wrap.querySelector(tab.dataset.tabTarget);

            console.log(tab.dataset.tabTarget);

            const mediaTarget = document.querySelector(`[data-tab-media-target="${tab.dataset.tabTarget}"]`);
            const medias = document.querySelectorAll(`[data-tab-media-target]`);
            medias.forEach(media => {
                media.classList.remove('active')
            });
            mediaTarget?.classList.add('active');

            tabContents.forEach(tabContent => {
                tabContent.classList.remove('active')
            });
            tabs.forEach(tab => {
                tab.classList.remove('active')
            });
            tab.classList.add('active')
            target.classList.add('active')

            if (!settings) return;
            const settingData = JSON.parse(settings.innerHTML);
            let setting = settingData.find(setting => setting.id == tab.dataset.tabTarget);
            let defaults = settingData.find(setting => setting.id == 'default');

            if (!setting) return;
            content_heading.innerHTML = setting.content_heading || defaults.content_heading;
            content_text.innerHTML = setting.content_text || defaults.content_text;
        })
    })
})